"use client"

import React from "react"

import EmptyFilteredContent from "compositions/events/EmptyFilteredContent/EmptyFilteredContent"

import useFilteredLeagues from "./utils/useFilteredLeagues"
import SxLeague from "../League/SxLeague"

type SxFilteredLeaguesProps = {
  sportSlug: string
  leagues: any
  isPage?: boolean
  showFilter?: boolean
}

const SxFilteredLeagues: React.FC<SxFilteredLeaguesProps> = ({
  sportSlug,
  leagues,
  isPage,
  showFilter = false,
}) => {
  const filteredLeagues = useFilteredLeagues(leagues)

  if (!filteredLeagues?.length) {
    return <EmptyFilteredContent />
  }

  return (
    <>
      {filteredLeagues.map((league, index) => (
        <SxLeague
          key={`${league.countrySlug}-${league.slug}`}
          sportSlug={sportSlug}
          league={league}
          isPage={isPage}
          showFilter={showFilter}
          isFirstLeague={index === 0}
        />
      ))}
    </>
  )
}

export default SxFilteredLeagues
